import React from "react";
import SubcontractorTimesheetsTable from "./components/SubcontractorTimesheetsTable";
import { ListProps } from "react-admin";
import HeaderContent from "../../components/layout/components/HeaderContent";

const SubcontractorTimesheetList = (props: ListProps) => {
  const breadcrumb = [
    { link: "/subcontractorTimesheets", title: "Subcontractor Timesheets" },
  ];

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle="Subcontractor Timesheets"
      />

      <SubcontractorTimesheetsTable listProps={props} />
    </>
  );
};

export default SubcontractorTimesheetList;
